// ========================================================================
// 📁 JobSection.js
// ✨ CLEVER DESIGN: This is the core of the refactor. A single, reusable
// component that replaces duplicated code for "Before", "After", and "Design".
// ========================================================================

import {Ruler, FileText} from "lucide-react";
import ImageSlider from "./ImageSlider";
import {InfoRow} from "./InfoCard";
import {NoDataMessage} from "./ApprovalActions";
import React from "react";
import * as PropTypes from "prop-types";


function GeometryData(props) {
    return null;
}

GeometryData.propTypes = {geometryData: PropTypes.any};
export const JobSection = ({ title, data, jobId, icon, gradient, borderColor, actions }) => {
    const hasData = !!data;
    const hasGeometry = hasData && data.geometryData;
    const geometry = data?.geometryData || {};

    return (
        <div className={`bg-gradient-to-br ${gradient} rounded-xl p-4 border ${borderColor} space-y-4`}>
            <div className="flex items-center space-x-3">
                {icon}
                <h4 className="text-lg font-semibold text-gray-900">{title}</h4>
            </div>

            {!hasData && <NoDataMessage />}

            {hasData && (
                <>
                    <ImageSlider images={data.images} altText={title} jobId={jobId} />

                    {hasGeometry && (
                        <div className="bg-white/50 rounded-lg p-4">
                            <div className="flex items-center space-x-3 mb-4">
                                <Ruler className="w-5 h-5 text-gray-500"/>
                                <h5 className="font-medium text-gray-700">Geometry Data</h5>
                            </div>
                            <div className="grid grid-cols-3 gap-4">
                                <div className="text-center">
                                    <p className="text-2xl font-bold text-gray-900">{data.geometryData.width.toFixed(2)}</p>
                                    <p className="text-sm text-gray-500">Width (ft)</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-2xl font-bold text-gray-900">{data.geometryData.length.toFixed(2)}</p>
                                    <p className="text-sm text-gray-500">Length (ft)</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-2xl font-bold text-gray-900">
                                        {(data.geometryData.width * data.geometryData.length).toFixed(1)}
                                    </p>
                                    <p className="text-sm text-gray-500">Area (ft²)</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {title !== "Design" && <div className="bg-white/60 rounded-lg p-3">
                        <InfoRow icon={<FileText className="w-4 h-4"/>} label="Remarks" value={data.remark}/>
                    </div>}

                    {actions}
                </>
            )}
        </div>
    );
};
